import { createDirectus, rest } from '@/lib/helpers/directus';

export const directus = createDirectus(process.env.NEXT_APP_DIRECTUS_URL).with(rest());